export const FINANCE_TAB_KEY = 'finance';

export const FORMIK_FINANCE_FIELD_IDS = {
  IS_VAT_REGISTERED: 'is_vat_registered',
  VAT_NUMBER: 'vat_number',

  IBAN_LANGUAGE: 'language',
  IBAN: 'iban',
  SWIFT_BIC: 'swift_bic',

  UK_BANK_SORT_CODE: 'uk_sort_code',
  UK_BANK_ACCOUNT_NUMBER: 'uk_bank_account_number',

  AU_BSB_NUMBER: 'au_bsb_number',
  AU_BANK_ACCOUNT_NUMBER: 'au_bank_account_number',

  NZ_BANK_ACCOUNT_NUMBER: 'nz_bank_account_number',

  ACCOUNT_DETAILS: 'account_details',

  IS_TRUSTED_PAYEE: 'is_trusted_payee',
  TRUSTED_PAYEE_VALID_TO: 'trusted_payee_valid_to',
  TRUSTED_PAYEE_PER_PAYMENT_LIMIT: 'trusted_payee_per_payment_limit',

  BANK_PROOF_DOCUMENT_ID: 'bank_proof_document_id',
  REMOVE_BANK_PROOF_DOCUMENT: 'remove_bank_proof_document',

  REASON: 'reason',
  EXPLANATION: 'explanation',
};

// The 'active' member of the backend's derived Contact.trusted_payee_status ('active' | 'not_active').
export const TRUSTED_PAYEE_ACTIVE_STATUS = 'active';

// The arrangement fields the backend applies as its own top-level `trusted_payee` PATCH section,
// outside the finance-verification / change-reason path. They live in the finance tab's form state,
// so the tab has to compare and send them separately from the finance fields proper.
export const TRUSTED_PAYEE_FIELD_IDS = [
  FORMIK_FINANCE_FIELD_IDS.IS_TRUSTED_PAYEE,
  FORMIK_FINANCE_FIELD_IDS.TRUSTED_PAYEE_VALID_TO,
  FORMIK_FINANCE_FIELD_IDS.TRUSTED_PAYEE_PER_PAYMENT_LIMIT,
];

export const SUPPORTED_IBAN_LANGUAGES = ['fr', 'nl', 'en', 'de', 'it', 'es', 'pt', 'pl', 'ga', 'sv', 'no', 'fi', 'da'];
